var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 101.44 102.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .skin {\n        fill: #dcba8b;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "disgusted"
  }, /*#__PURE__*/React.createElement("path", {
    className: "skin",
    d: "M67,92.5a14.49,14.49,0,0,1,27.08-7.18,28.76,28.76,0,0,0,7.36-18.75C101.44,46.62,78.37,0,50.36,0S0,46.62,0,66.57A27.76,27.76,0,0,0,5.12,82.39,14.49,14.49,0,0,1,28.44,99a67.94,67.94,0,0,0,22.28,3.66,69,69,0,0,0,18.51-2.49A14.45,14.45,0,0,1,67,92.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset11);
export default __webpack_public_path__ + "static/media/Asset 11.f7ba63e6.svg";
export { ForwardRef as ReactComponent };